import { Config } from 'app/config/config';
import { ApiService } from 'app/shared/services/api.service';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoggerService {

  constructor(private apiService: ApiService) { }

  public logger(content: string, type: string)
  {
    var request = {
      type: type,
      content: content
    };
    this.apiService.post(Config.utopApiPath.logger, request).subscribe((res) => {console.info('Logger OK');});
  }
}
